// src/components/RenderObjetos.tsx
import React, { useRef, useEffect } from 'react';
import { Objeto } from '../../../../../types';

interface ObjetosProps {
  objetos: Objeto[];
  actionType: string; // 'restaurant' | 'reservation' | 'configuration'
  scaleFactor: number;
  onDragStart: (e: React.DragEvent<HTMLDivElement>, item: Objeto) => void;
  setSelectedItem: (item: Objeto) => void;
  selectedItem: any;
  setPxPerCellX: (pxPerCellX: number) => void;
  setPxPerCellY: (pxPerCellY: number) => void;
}

const RenderObjetos: React.FC<ObjetosProps> = ({
  objetos,
  actionType,
  scaleFactor,
  onDragStart,
  selectedItem,
  setSelectedItem,
  setPxPerCellX,
  setPxPerCellY,
}) => {
  const selectedItemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedItemRef.current && selectedItem) {
      const { width: pxW, height: pxH } = selectedItemRef.current.getBoundingClientRect();
      const cellsW = selectedItem.width;
      const cellsH = selectedItem.height;
      setPxPerCellX(pxW / cellsW);
      setPxPerCellY(pxH / cellsH);
    }
  }, [selectedItem, setPxPerCellX, setPxPerCellY]);

  return (
    <>
      {objetos.map(objeto => {
        const isSelected = selectedItem?.id === objeto.id;
        // outer uses scaled position & size
        const style: React.CSSProperties = {
          position: 'absolute',
          left:   `calc(${objeto.x_pos * scaleFactor}em * var(--salon-objects-compensation, 1.1))`,
          top:    `calc(${objeto.y_pos * scaleFactor}em * var(--salon-objects-compensation, 1.1))`,
          width:  `${objeto.width  * scaleFactor}px`,
          height: `${objeto.height * scaleFactor}px`,
        };

        return (
          <div
            ref={isSelected ? selectedItemRef : null}
            key={objeto.id}
            draggable
            onDragStart={e => onDragStart(e, objeto)}
            className={`objeto${isSelected ? ' selected' : ''}`}
            onClick={() => setSelectedItem(objeto)}
            style={style}
          >
            {/* inner wrapper scales content only */}
            <div
              className="objeto-inner"
              style={{
                transform: `scale(${scaleFactor})`,
                transformOrigin: 'center center'
              }}
            >
              {objeto.name}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default RenderObjetos;
